module.exports = __webpack_public_path__ + "img/fsecure_01.f482ea4d.jpg";